export default __webpack_public_path__ + "static/wright-0bbfdac6d65f1c5e1dea11392fe9f75f.jpg";